import { SVG } from "./Icons"; // Relative so it also works in sanity

const AnalyseIcon = () => (
  <SVG size={24}>
    <path d="M20 19.59V8L14 2H6C5.40342 2 4.50002 2 4.00001 2.00001C4 2.5 4.00543 3.31352 4.01 4L4 20C4 20.5373 4 21.5 4 22C4.5 22 5.42728 22 5.99 22H18C18.45 22 19 22 19.5 22L14.76 17.17C13.96 17.69 13.02 18 12 18C9.24 18 7 15.76 7 13C7 10.24 9.24 8 12 8C14.76 8 17 10.24 17 13C17 14.02 16.69 14.96 16.17 15.75L20 19.59ZM9 13C9 14.66 10.34 16 12 16C13.66 16 15 14.66 15 13C15 11.34 13.66 10 12 10C10.34 10 9 11.34 9 13Z" />
  </SVG>
);

const AudioIcon = () => (
  <SVG size={24}>
    <path d="M12 3V13.55C11.41 13.21 10.73 13 10 13C7.79 13 6 14.79 6 17C6 19.21 7.79 21 10 21C12.21 21 14 19.21 14 17V7H18V3H12Z" />
  </SVG>
);

const ChartIcon = () => (
  <SVG size={24}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 3V21V22H3H21V20H4V3H2ZM10.7095 11.8495L7.00003 17L5.44184 15.9948L10.2483 9.34931L14.4035 12.0299L19.4535 4.23018L20.9182 5.17507L14.8647 14.5301L10.7095 11.8495Z"
    />
  </SVG>
);

const Chart2Icon = () => (
  <SVG size={24}>
    <path d="M23 8.27277C23 9.37277 22.1 10.2728 21 10.2728C20.82 10.2728 20.65 10.2528 20.49 10.2028L16.93 13.7528C16.98 13.9128 17 14.0928 17 14.2728C17 15.3728 16.1 16.2728 15 16.2728C13.9 16.2728 13 15.3728 13 14.2728C13 14.0928 13.02 13.9128 13.07 13.7528L10.52 11.2028C10.36 11.2528 10.18 11.2728 10 11.2728C9.82 11.2728 9.64 11.2528 9.48 11.2028L4.93 15.7628C4.98 15.9228 5 16.0928 5 16.2728C5 17.3728 4.1 18.2728 3 18.2728C1.9 18.2728 1 17.3728 1 16.2728C1 15.1728 1.9 14.2728 3 14.2728C3.18 14.2728 3.35 14.2928 3.51 14.3428L8.07 9.79277C8.02 9.63277 8 9.45277 8 9.27277C8 8.17277 8.9 7.27277 10 7.27277C11.1 7.27277 12 8.17277 12 9.27277C12 9.45277 11.98 9.63277 11.93 9.79277L14.48 12.3428C14.64 12.2928 14.82 12.2728 15 12.2728C15.18 12.2728 15.36 12.2928 15.52 12.3428L19.07 8.78277C19.02 8.62277 19 8.45277 19 8.27277C19 7.17277 19.9 6.27277 21 6.27277C22.1 6.27277 23 7.17277 23 8.27277Z" />
  </SVG>
);

const Chart3Icon = () => (
  <SVG size={24}>
    <path d="M17 4H20V20H17V4ZM5 14H8V20H5V14ZM11 9H14V20H11V9Z" />
  </SVG>
);

const CodeIcon = () => (
  <SVG size={24}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.8 12L7.4 16.6L6 18L0 12L6 6L7.4 7.4L2.8 12ZM21.2 12L16.6 16.6L18 18L24 12L18 6L16.6 7.4L21.2 12Z"
    />
    <rect
      x="12.9795"
      y="6.0079"
      width="2"
      height="12"
      transform="rotate(19.3673 12.9795 6.0079)"
    />
  </SVG>
);

const ComputerIcon = () => (
  <SVG size={24}>
    <path d="M23 2H1V18H10V20H8V22H16V20H14V18H23V16H3V4H21V18H23V2Z" />
  </SVG>
);

const ConnectionIcon = () => (
  <SVG size={24}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.7577 15.8363C20.1555 15.8781 21.4189 16.8345 21.7848 18.2549C22.2282 19.9763 21.1884 21.7377 19.4671 22.1811C17.7457 22.6246 15.9843 21.5848 15.5408 19.8634C15.4802 19.6282 15.4517 19.3847 15.4473 19.1464L6.68902 16.6597C6.24938 17.3431 5.57565 17.8701 4.73101 18.0877C2.95618 18.5449 1.15441 17.4813 0.697194 15.7064C0.239976 13.9316 1.30359 12.1298 3.07841 11.6726C3.92306 11.455 4.76756 11.5909 5.48263 11.9768L11.8883 5.64067C11.7715 5.40853 11.6653 5.17364 11.5992 4.91704C11.142 3.14221 12.2056 1.34044 13.9805 0.883225C15.7553 0.426008 17.5571 1.48962 18.0143 3.26445C18.394 4.73848 17.7247 6.23109 16.4702 6.95661L18.7577 15.8363ZM16.8393 16.4066L14.516 7.38779C14.0618 7.34522 13.6254 7.20811 13.2288 6.99411L6.8232 13.3302C6.94001 13.5623 7.04612 13.7972 7.11223 14.0538C7.17833 14.3104 7.19891 14.5674 7.20881 14.827L15.975 17.3003C16.2033 16.9547 16.4939 16.6486 16.8393 16.4066Z"
    />
  </SVG>
);

const Connection2Icon = () => (
  <SVG size={24}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.6973 13L9.2 16.6L7.83784 18L2 12L7.83784 6L9.2 7.4L5.6973 11L9.99998 11L18.3027 11L14.8 7.4L16.1622 6L22 12L16.1622 18L14.8 16.6L18.3027 13L14 13L5.6973 13Z"
    />
  </SVG>
);

const ConvertDataIcon = () => (
  <SVG size={24}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 2H4V22H20V8L14 2ZM13.7568 14L7 14V12L13.7568 12L11 9.16667L12.1351 8L17 13L12.1351 18L11 16.8333L13.7568 14Z"
    />
  </SVG>
);

const DataIcon = () => (
  <SVG size={24}>
    <path d="M12 1L2 6.69605L12 12L22 6.52477L12 1Z" />
    <path d="M12 14.5L4.67397 10.5777L2 12.1293L12 17.5L22 11.958L19.2961 10.4937L12 14.5Z" />
    <path d="M12 20L4.67397 16.0915L2 17.6432L12 23L22 17.4719L19.2961 16.0076L12 20Z" />
  </SVG>
);

const DatabaseIcon = () => (
  <SVG size={24}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 20H2V16H22V20ZM6 17H4V19H6V17ZM2 8V4H22V8H2ZM4 7H6V5H4V7ZM22 14H2V10H22V14ZM6 11H4V13H6V11Z"
    />
  </SVG>
);

const DataStoriesIcon = () => (
  <SVG size={24}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 11.9733C2 6.78811 5.96623 2.52247 11 2V12.4206L17.9358 20.0433C16.2761 21.2732 14.2228 22.0008 12.0004 22.0008C6.47721 22.0008 2 17.5114 2 11.9733ZM21.9583 11.9733C21.9583 14.5299 21.0034 16.8628 19.4325 18.6338L13 11.5677V2C18.0338 2.52247 21.9583 6.78811 21.9583 11.9733Z"
    />
  </SVG>
);

const DigitizeIcon = () => (
  <SVG size={24}>
    <path d="M20 6H12L10 4H2.01C2.00001 4.5 2.01001 4.9 2.01001 6L2.00001 18C2.00001 19.1 2 19 2 20H22C22 19.5 22 19.1 22 18V6C21 6 21.1 6 20 6ZM14 16H6.00001V14H14V16ZM18 12H6.00001V10H18V12Z" />
  </SVG>
);

const Digitize2Icon = () => (
  <SVG size={24}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 8V15H17V8H20V18H4V8H7ZM7 6V2H14L17 4.56491V6H22V18V20H20H14V22H16V24H8V22H10V20H2V6H7Z"
    />
  </SVG>
);

const HandWrittenIcon = () => (
  <SVG size={24}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.615 4.25L17.865 0.5L15.205 3.16L18.955 6.91L21.615 4.25ZM17.75 8.00001L14 4.25001L4 14.25V18H7.75L17.75 8.00001ZM24 21H0V23H24V21Z"
    />
  </SVG>
);

const HighLightIcon = () => (
  <SVG size={24}>
    <path d="M18 2H4.00001C3.99999 3 4 2.9 4 4V22C5 22 4.9 22 6 22H20C20 21 20 21.1 20 20L20 2.00001C19 2 19.1 2 18 2ZM6 4H11V12L8.5 10.5L6 12V4Z" />
  </SVG>
);

const ImageIcon = () => (
  <SVG size={24}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 3H21V21H3V3ZM11 16.51L8.5 13.5L5 18H19L14.5 12L11 16.51Z"
    />
  </SVG>
);

const MediaIcon = () => (
  <SVG size={24}>
    <path d="M13.5 2.1C13 2 12.5 2 12 2C11.5 2 11 2 10.5 2.1C5.7 2.8 2 7 2 12C2 17 5.7 21.2 10.5 21.9C11 22 11.5 22 12 22C12.5 22 13 22 13.5 21.9C18.3 21.2 22 17 22 12C22 7 18.3 2.8 13.5 2.1ZM20.3 11.2H16.6C16.5 8.6 15.6 6.1 14.3 4C17.5 4.9 19.9 7.7 20.3 11.2ZM9.1 11.2C9.3 8.4 10.3 5.8 12 3.7C13.7 5.8 14.7 8.4 14.9 11.2H9.1ZM14.9 13C14.7 15.8 13.7 18.3 12 20.3C10.4 18.3 9.3 15.7 9.1 13H14.9ZM9.7 4C8.4 6.1 7.6 8.6 7.4 11.2H3.7C4.1 7.7 6.5 4.9 9.7 4ZM3.7 13H7.4C7.6 15.6 8.4 18 9.7 20C6.5 19.1 4.1 16.4 3.7 13ZM14.3 20C15.6 17.9 16.4 15.5 16.6 13H20.3C19.9 16.4 17.5 19.1 14.3 20Z" />
  </SVG>
);

const MetaDataIcon = () => (
  <SVG size={24}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 2H14L20 8V22H4V2ZM8 18H16V16H8V18ZM16 14H8V12H16V14ZM13 3.5V9H18.5L13 3.5Z"
    />
  </SVG>
);

const TextIcon = () => (
  <SVG size={24}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 2L20 8V22H4V2H14ZM15 18L14 15H10L9 18H7L11 7H13L17 18H15ZM10.5 13H13.5L12.02 9L10.5 13Z"
    />
  </SVG>
);

const TextFormatIcon = () => (
  <SVG size={24}>
    <path d="M15 15H3V17H15V15ZM15 7H3V9H15V7ZM3 13H21V11H3V13ZM3 21H21V19H3V21ZM3 3V5H21V3H3Z" />
  </SVG>
);

const VideoIcon = () => (
  <SVG size={24}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 4H23V20H1V4ZM16 12L9 7V17L16 12Z"
    />
  </SVG>
);

const Video2Icon = () => (
  <SVG size={24}>
    <path d="M18 4L20 8H17L15 4H13L15 8H12L10 4H8L10 8H7L5 4H2.01001C2 5 2.01 4.9 2.01 6L2 18C2 19.1 2 18.5 2 20H22C22 17.5 22 19.1 22 18V4H18Z" />
  </SVG>
);

export const LandingIcons = {
  AnalyseIcon: AnalyseIcon,
  AudioIcon: AudioIcon,
  ChartIcon: ChartIcon,
  Chart2Icon: Chart2Icon,
  Chart3Icon: Chart3Icon,
  CodeIcon: CodeIcon,
  ComputerIcon: ComputerIcon,
  ConnectionIcon: ConnectionIcon,
  Connection2Icon: Connection2Icon,
  ConvertDataIcon: ConvertDataIcon,
  DataIcon: DataIcon,
  DatabaseIcon: DatabaseIcon,
  DataStoriesIcon: DataStoriesIcon,
  DigitizeIcon: DigitizeIcon,
  Digitize2Icon: Digitize2Icon,
  HandWrittenIcon: HandWrittenIcon,
  HighLightIcon: HighLightIcon,
  ImageIcon: ImageIcon,
  MediaIcon: MediaIcon,
  MetaDataIcon: MetaDataIcon,
  TextIcon: TextIcon,
  TextFormatIcon: TextFormatIcon,
  VideoIcon: VideoIcon,
  Video2Icon: Video2Icon,
};
